import { MapPin } from "lucide-react";
import { INTERVENTION_ZONES } from "@/lib/site-data";

export const Zones = () => {
  return (
    <section id="zones" data-testid="zones-section" className="relative py-20 md:py-24 border-t border-bgtp-line">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="grid lg:grid-cols-12 gap-10">
          <div className="lg:col-span-4">
            <div className="eyebrow mb-4">Zones d'intervention</div>
            <h2 className="font-heading text-4xl md:text-5xl uppercase tracking-tight leading-[0.95] text-white">
              On se déplace <br />
              <span className="text-bgtp-orange">dans l'Ain</span><br />
              <span className="silver-text">& alentours.</span>
            </h2>
            <p className="mt-5 text-white/70 text-sm leading-relaxed">
              Basés à Saint-Didier-sur-Chalaronne (01), nous intervenons dans tout l'Ain
              et les départements limitrophes (Saône-et-Loire, Rhône) pour vos chantiers
              de terrassement, aménagement extérieur et rénovation.
            </p>
          </div>

          <div className="lg:col-span-8">
            <div className="relative border border-bgtp-line bg-bgtp-ink p-6 md:p-8">
              <div className="absolute -top-3 left-6 bg-bgtp-black px-3 text-[10px] tracking-[0.3em] uppercase text-bgtp-orange">Villes desservies</div>
              <ul className="grid grid-cols-2 sm:grid-cols-3 gap-x-6 gap-y-3 mt-2">
                {INTERVENTION_ZONES.map((city, i) => (
                  <li
                    key={city}
                    data-testid={`zone-${i}`}
                    className="flex items-center gap-2 text-sm text-white/85 hover:text-bgtp-orange transition-colors border-b border-bgtp-line/60 pb-2"
                  >
                    <MapPin className="w-3.5 h-3.5 text-bgtp-orange flex-shrink-0" />
                    <span>{city}</span>
                  </li>
                ))}
              </ul>
              <p className="mt-6 text-xs text-bgtp-steel">
                Votre commune n'est pas dans la liste ? Contactez-nous, on étudie chaque demande.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
